import React, { Component, Fragment } from 'react';
import DEFINE, {PATHS, FEATURE_FLAGS} from "../../../../constants/Define";
import * as Func from '../../../../helpers/functions';
import * as HMS from "../../common/component/Index";
import BookablePackageRateList from './BookablePackageRateList';
import Ripple from '../../common/component/Ripple';
import { Button, Alert, message, Modal } from 'antd';
import update from 'immutability-helper';
import { isEqual } from 'lodash';
import { getContentLanguage } from '../../../../utils/commonUtils';

const { confirm } = Modal

let permisionActions = {};
export default class BookablePackageRate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filters: {
                hotelId: this.props.match.params.hotel_id,
            },
            isSort: false,
            bookablePackageRates: [],
        };
        this.ChildElement = React.createRef();
    }

    componentDidMount() {
        permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.BOOKABLEPACKAGERATES);
        const hotelId = this.props.match.params.hotel_id;
        this.props.getListBookablePackageRates(hotelId, this.state.filters);
        if(this.state.filters?.hotelId){
            this.props.getHotelDetail(this.state.filters.hotelId);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.bookablePackageRateState && !isEqual(nextProps.bookablePackageRateState.dataList, this.props.bookablePackageRateState.dataList)) {
            this.setState({ bookablePackageRates: nextProps.bookablePackageRateState.dataList });
        }
    }

    showConfirmSync = () => {
        const { t, match } = this.props;
        confirm({
            title: t('action.sync'),
            content:  <span><span>{t('item.bookablePackageRate.confirmSync')}</span></span>,
            onOk: () => {
                this.props.syncAllBookablePackageRates(match.params.hotel_id, true)
            },
            onCancel() {},
            okText: t(`action.sync`),
            cancelText: t(`action.cancel`)
          });
    }
    
    render() {
        const { t, match, hotelState } = this.props;
        const { isFetching, dataList, isFetchSync, isUpdating } = this.props.bookablePackageRateState;
        const { isSort, bookablePackageRates } = this.state;

        return (
            <Fragment>
                <HMS.PageListComponent onChangeLanguage={FEATURE_FLAGS.TRANSLATE_ENABLE && this.onChangeLanguage}>
                    <HMS.HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'bookablePackageRate'}
                        titleHeader={`${t('navigation.bookablePackageRates')} - ${hotelState?.detail?.hotel?.name || ""}`}
                        onClickBack={this.onClickBack}
                        componentRight={
                            <Fragment>
                                {
                                !isSort ? <Ripple color="rgba(255, 255, 255, 0.8)" waitForEffect={true}>
                                    <Button className='btn btn-primary' onClick={this.toggleSort}>{t(`action.sort`)}</Button>
                                </Ripple>
                                : <Fragment>
                                    <Ripple color="rgba(255, 255, 255, 0.8)" waitForEffect={true}>
                                        <Button className='btn btn-default mr-2' onClick={this.cancelSort}>{t(`action.cancel`)}</Button>
                                    </Ripple>
                                    <Ripple color="rgba(255, 255, 255, 0.8)" waitForEffect={true}>
                                        <Button className='btn btn-primary' disabled={isEqual(dataList, bookablePackageRates)} onClick={this.applySortList}>{t(`action.save`)}</Button>
                                    </Ripple>
                                </Fragment>
                                }
                                {
                                    permisionActions && permisionActions.allowSync &&
                                    <Ripple color="rgba(255, 255, 255, 0.8)" waitForEffect={true}>
                                        <Button
                                            icon="sync"
                                            loading={isFetchSync}
                                            onClick={this.showConfirmSync}
                                            className='btn btn-primary ml-3'>
                                                 {t(`action.sync`)}</Button>
                                    </Ripple>
                                }
                            </Fragment>
                        }
                    />
                    <Alert message={t('notification.infoSort')} type="info" showIcon />
                    <BookablePackageRateList 
                        getListRates={() => this.props.getListRates(this.state.filters)}
                        loading={isFetching}
                        loadingStatus={isUpdating}
                        onUpdateActive={this.onUpdateActive}
                        hotelId={match.params.hotel_id}
                        permisions={permisionActions}
                        dataList={bookablePackageRates}
                        onChange={this.onTableChange}
                        isSort={isSort}
                        moveRow={this.moveRow}
                        onSyncRateLanguage={this.onSyncRateLanguage}
                        syncOneBookablePackageRate={this.props.syncOneBookablePackageRate}
                        />
                </HMS.PageListComponent>
            </Fragment>
        );
    }

    onUpdateActive = (isActive, record) => {
        const rate = this.state.bookablePackageRates.find(item => item.bookableId === record.bookableId);
        if (!rate || this.state.isSort || this.props.bookablePackageRateState.isUpdating || !permisionActions.allowUpdate) return;

        this.props.updateBookablePackageRate({ ...rate.export(), isActive }, rate.bookableId, {
            onSuccess: () => this.props.getListBookablePackageRates(this.props.match.params.hotel_id, this.state.filters),
        });
    };

    onTableChange = (pagination, filters, sorter) => {
        let newFilters = Func.genaratePaginateFilterSort(pagination, filters, sorter);
        const hotelId = this.props.match.params.hotel_id;
        this.setState({
            filters: newFilters
        });
        this.props.getListBookablePackageRates(hotelId, newFilters);
    };

    onClickBack = () => {
        const { match } = this.props;
        if (Object.keys(match.params).length > 0 && match.params.hotel_id) {
            const path = Func.getPathWithParams(PATHS.HOTEL.DETAIL.path, { id: match.params.hotel_id })
            this.props.history.push(path);
        }
    }

    toggleSort = () => {
        if(this.state.bookablePackageRates.length > 0) {
            this.setState({ isSort: true })
            message.info(this.props.t('notification.acceptSort'));
        }
    }

    cancelSort = () => {
        this.setState({ bookablePackageRates: this.props.bookablePackageRateState.dataList, isSort: false })
    }

    moveRow = (hoverIndex, dragFields, headSelect) => {
        // const { bookablePackageRates } = this.state;
        // const dragRow = bookablePackageRates[dragIndex];
        let lengthRows = dragFields.length;
        this.setState(
          update(this.state, {
            bookablePackageRates: {
                $splice: [[headSelect, lengthRows], 
                [
                    ( lengthRows === 1 || hoverIndex < headSelect) ? hoverIndex : (hoverIndex - lengthRows) 
                    , 0, ...dragFields
                ]],
            },
          }),
        );
    };

    applySortList = () => {
        const { bookablePackageRates } = this.state;
        const hotel_id = this.props.match.params.hotel_id;
        const languageCode = getContentLanguage()
        const sortedRates = bookablePackageRates.map((item, index) => ({ bookablePackageRateId: item.bookableId, languageCode, order: index }))
        this.props.sortBookablePackageRates(sortedRates, hotel_id);
        this.setState({ isSort: false })
    }

    onSyncRateLanguage = (obj) => {
        const { filters } = this.state;
        this.props.syncRateLanguage({
            ...obj,
            filters: filters
        })
    }
}
